<form [formGroup]="form">
  <mat-list>
    <mat-accordion multi="true">
      @for (group of settings(); track group) {
        <div [formGroup]="form" class="form-row">
          <ldw-vmp-form-group
            [captionWidth]="captionWidth()"
            [valueWidth]="valueWidth()"
            [form]="form"
            [vmpList]="group" />
        </div>
      }
    </mat-accordion>
  </mat-list>
</form>
